import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { employeesService } from '@/features/employees/services/employees.service';
import { RecessControlList } from '@/features/employees/components/RecessControlList';
import { RecessControlCalendar } from '@/features/employees/components/RecessControlCalendar';

export const Route = createFileRoute('/_authenticated/employees/recess-control')({
  component: RecessControlPage,
});

function RecessControlPage() {
  return (
    <PermissionGate permission={Permission.EMPLOYEES_VIEW}>
      <RecessControlPageContent />
    </PermissionGate>
  );
}

function RecessControlPageContent() {
  const { data: employees = [], isLoading } = useQuery({
    queryKey: ['recess-control-list'],
    queryFn: () => employeesService.getRecessControlList(),
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Controle de Recesso</h1>
        <p className="text-muted-foreground">
          Gerencie recessos e férias de todos os prestadores.
        </p>
      </div>

      <Tabs defaultValue="list" className="space-y-4">
        <TabsList>
          <TabsTrigger value="list">Lista</TabsTrigger>
          <TabsTrigger value="calendar">Calendário</TabsTrigger>
        </TabsList>
        <TabsContent value="list">
          <RecessControlList employees={employees} isLoading={isLoading} />
        </TabsContent>
        <TabsContent value="calendar">
          <RecessControlCalendar />
        </TabsContent>
      </Tabs>
    </div>
  );
}
